function e(t, n) {
  return function() {
    return n.call(this, t.apply(this, arguments));
  };
}
export {
  e as default
};
